import React from 'react';
import { Icon } from '@iconify/react';
import Modal from '@/components/ui/Modal';
import Button from '@/components/ui/Button';
import type { CustomFormField, CustomFormAnswerItem } from '@/services/communityService';

interface CustomFormAnswersViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  participantName: string;
  answers?: CustomFormAnswerItem[];
  customFormQuestions?: CustomFormField[];
}

export const CustomFormAnswersViewModal: React.FC<CustomFormAnswersViewModalProps> = ({
  isOpen,
  onClose,
  participantName,
  answers = [],
  customFormQuestions = [],
}) => {
  if (!isOpen) return null;

  // Build merged items: use answers or fallback to customForm questions matching question_id
  const hasAnswers = answers && answers.length > 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Jawaban Formulir"
      subtitle={`Data pendaftaran dari ${participantName}`}
      size="md"
      position="bottom"
    >
      <div className="space-y-4 pt-1 pb-2">
        {!hasAnswers ? (
          <div className="text-center py-8 px-4">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3 text-gray-400">
              <Icon icon="ph:clipboard-text-bold" className="w-6 h-6" />
            </div>
            <h4 className="text-sm font-bold text-[#0E1726] mb-1">
              Belum Ada Jawaban Formulir
            </h4>
            <p className="text-xs text-gray-500 max-w-xs mx-auto">
              Peserta ini belum mengisi pertanyaan tambahan atau mendaftar sebelum formulir diaktifkan.
            </p>
          </div>
        ) : (
          <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1">
            {answers.map((ans, idx) => {
              const qId = ans.field_id || ans.question_id;
              const matchedQ = customFormQuestions.find(
                (q) => q.id === qId
              );
              const questionTitle = ans.title || matchedQ?.title || `Pertanyaan #${idx + 1}`;
              const answerValue =
                ans.value !== undefined && ans.value !== null && String(ans.value).trim() !== ''
                  ? String(ans.value)
                  : '-';

              return (
                <div
                  key={qId || idx}
                  className="p-3.5 rounded-2xl bg-gray-50 border border-gray-100 space-y-1"
                >
                  <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider block">
                    {questionTitle}
                  </span>
                  <p className="text-sm font-bold text-[#0E1726] break-words">
                    {answerValue}
                  </p>
                </div>
              );
            })}
          </div>
        )}

        <div className="pt-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            className="w-full rounded-2xl py-2.5 font-bold border-gray-200 text-gray-700 hover:bg-gray-50"
          >
            Tutup
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomFormAnswersViewModal;
